export default __webpack_public_path__ + "static/media/jxsport_receipt.88ada8af.jpg";